/* OohDibs commerce layer – vanilla JS, no dependencies. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cfg = window.odConfig || {};

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var format = cfg.moneyFormat || '${{amount}}';
    var value = (Math.round(cents) / 100).toFixed(2);
    function delimit(numStr, thousands, decimal) {
      var parts = numStr.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] !== undefined ? parts[0] + decimal + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delimit(String(Math.round(cents / 100)), ',', '.');
        case 'amount_with_comma_separator': return delimit(value, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(String(Math.round(cents / 100)), '.', ',');
        case 'amount_with_apostrophe_separator': return delimit(value, "'", '.');
        default: return delimit(value, ',', '.');
      }
    });
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) { var err = new Error(data.description || data.message || 'Request failed'); err.data = data; throw err; }
        return data;
      });
    });
  }

  function postJSON(path, body) {
    return fetchJSON(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function store(kind) {
    try { return window[kind]; } catch (e) { return null; }
  }

  /* ---------- UTM / creative attribution ---------- */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var attribution = (function () {
    var params = new URLSearchParams(window.location.search);
    var touch = {};
    UTM_KEYS.forEach(function (k) { if (params.get(k)) touch[k] = params.get(k).slice(0, 120); });
    var ls = store('localStorage');
    var first = null, last = null;
    try {
      first = JSON.parse((ls && ls.getItem('od_first_touch')) || 'null');
      last = JSON.parse((ls && ls.getItem('od_last_touch')) || 'null');
    } catch (e) { /* ignore */ }
    if (Object.keys(touch).length) {
      touch.landing = window.location.pathname;
      touch.ts = new Date().toISOString();
      if (!first) { first = touch; try { ls && ls.setItem('od_first_touch', JSON.stringify(first)); } catch (e) { /* ignore */ } }
      last = touch;
      try { ls && ls.setItem('od_last_touch', JSON.stringify(last)); } catch (e) { /* ignore */ }
    }
    return {
      toCartAttributes: function () {
        var out = {};
        function flat(prefix, obj) {
          if (!obj) return;
          Object.keys(obj).forEach(function (k) { out[prefix + k] = obj[k]; });
        }
        flat('ft_', first);
        flat('lt_', last);
        return out;
      }
    };
  })();

  /* ---------- cart drawer ---------- */
  var Drawer = {
    el: null,
    lastFocus: null,
    init: function () {
      this.el = document.querySelector('[data-od-drawer]');
      if (!this.el) return;
      var self = this;
      document.addEventListener('click', function (e) {
        var open = e.target.closest('[data-od-cart-open]');
        if (open) { e.preventDefault(); self.open(); return; }
        if (e.target.closest('[data-od-cart-close]')) { e.preventDefault(); self.close(); return; }
        var qtyBtn = e.target.closest('[data-od-qty]');
        if (qtyBtn) { self.change(qtyBtn.dataset.key, parseInt(qtyBtn.dataset.odQty, 10)); return; }
        var offer = e.target.closest('[data-od-offer-add]');
        if (offer) { self.add([{ id: Number(offer.dataset.odOfferAdd), quantity: 1, properties: { _source: 'cart_offer' } }]); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.isOpen()) self.close(); });
    },
    isOpen: function () { return this.el && this.el.classList.contains('is-open'); },
    open: function () {
      if (!this.el) { window.location.href = root + 'cart'; return; }
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var close = this.el.querySelector('.od-drawer__close');
      if (close) close.focus({ preventScroll: true });
    },
    close: function () {
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    },
    busy: function (state) { if (this.el) this.el.classList.toggle('is-busy', state); },
    refresh: function () {
      var self = this;
      if (!this.el) return Promise.resolve();
      return fetch(root + '?section_id=od-cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-od-drawer-content]');
          var current = self.el.querySelector('[data-od-drawer-content]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          var count = fresh ? fresh.getAttribute('data-count') : null;
          if (count !== null) {
            document.querySelectorAll('[data-od-cart-count]').forEach(function (n) { n.textContent = count; n.dataset.count = count; });
          }
        });
    },
    add: function (items) {
      var self = this;
      this.busy(true);
      return postJSON('cart/add.js', { items: items })
        .then(function () {
          var attrs = attribution.toCartAttributes();
          if (Object.keys(attrs).length) return postJSON('cart/update.js', { attributes: attrs }).catch(function () {});
        })
        .then(function () { return self.refresh(); })
        .then(function () { self.busy(false); self.open(); })
        .catch(function (err) { self.busy(false); throw err; });
    },
    change: function (key, quantity) {
      var self = this;
      this.busy(true);
      return postJSON('cart/change.js', { id: key, quantity: quantity })
        .then(function () { return self.refresh(); })
        .catch(function () { return self.refresh(); })
        .then(function () { self.busy(false); });
    }
  };

  /* ---------- product buy box ---------- */
  function initProduct(el) {
    var dataNode = el.querySelector('[data-od-product-json]');
    if (!dataNode) return;
    var data = JSON.parse(dataNode.textContent);
    var form = el.querySelector('[data-od-form]');
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var button = el.querySelector('[data-od-atc]');
    var errorBox = el.querySelector('[data-od-error]');
    var sticky = document.querySelector('[data-od-sticky]');
    var addonsBox = el.querySelector('[data-od-addons]');

    function currentVariant() {
      var id = Number(idInput.value);
      return data.variants.filter(function (v) { return v.id === id; })[0] || data.variants[0];
    }
    function selectedBundle() {
      var input = el.querySelector('[data-od-bundle] input:checked');
      return input ? input.closest('[data-od-bundle]') : null;
    }
    function tierPrices(variant, qty, pct) {
      var list = [];
      for (var i = 0; i < qty; i++) list.push(variant);
      return listPrices(list, pct);
    }
    function listPrices(list, pct) {
      var full = 0, was = 0;
      list.forEach(function (v) {
        full += v.price;
        was += v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price;
      });
      return { now: Math.round(full * (100 - pct) / 100), was: was };
    }

    /* per-item variant choice inside Buy 2 / Buy 3 */
    var unitMemory = [];
    function variantById(id) { return data.variants.filter(function (v) { return v.id === id; })[0]; }
    function unitsBox(bundle) { return bundle ? bundle.querySelector('[data-od-units]') : null; }
    function unitList(bundle) {
      var qty = bundle ? Number(bundle.dataset.qty) : 1;
      unitMemory[0] = Number(idInput.value);
      var out = [];
      for (var i = 0; i < qty; i++) {
        var v = variantById(unitMemory[i]) || variantById(unitMemory[0]);
        if (!v || !v.available) v = variantById(unitMemory[0]);
        unitMemory[i] = v.id;
        out.push(v);
      }
      return out;
    }
    function renderUnits(bundle, list) {
      el.querySelectorAll('[data-od-units]').forEach(function (box) { box.classList.add('od-hidden'); box.textContent = ''; });
      var box = unitsBox(bundle);
      if (!box) return;
      box.textContent = '';
      var single = list.length === 1;
      var labelText = single ? (box.dataset.labelOne || box.dataset.label) : box.dataset.label;
      if (labelText) {
        var head = document.createElement('p');
        head.className = 'od-units__label';
        head.textContent = labelText;
        box.appendChild(head);
      }
      list.forEach(function (v, i) {
        var row = document.createElement('label');
        row.className = 'od-unit' + (single ? ' od-unit--single' : '');
        var img = document.createElement('img');
        img.alt = ''; img.width = 44; img.height = 44; img.loading = 'lazy';
        if (v.img) img.src = v.img;
        var num = document.createElement('span');
        num.className = 'od-unit__n';
        num.textContent = '#' + (i + 1);
        var select = document.createElement('select');
        select.setAttribute('data-od-unit', i);
        select.setAttribute('aria-label', single ? (labelText || 'Design') : (labelText || 'Item') + ' ' + (i + 1));
        data.variants.forEach(function (opt) {
          var o = document.createElement('option');
          o.value = opt.id;
          o.textContent = opt.title + (opt.available ? '' : ' – sold out');
          o.disabled = !opt.available;
          if (opt.id === v.id) o.selected = true;
          select.appendChild(o);
        });
        row.appendChild(img); if (!single) row.appendChild(num); row.appendChild(select);
        box.appendChild(row);
      });
      box.classList.remove('od-hidden');
    }

    function render() {
      var variant = currentVariant();
      var bundle = selectedBundle();
      var units = unitList(bundle);
      el.querySelectorAll('[data-od-bundle]').forEach(function (card) {
        var qty = Number(card.dataset.qty), pct = Number(card.dataset.pct);
        var p = card === bundle && unitsBox(bundle) ? listPrices(units, pct) : tierPrices(variant, qty, pct);
        card.classList.toggle('is-selected', card === bundle);
        card.querySelector('[data-od-bundle-price]').innerHTML = formatMoney(p.now);
        var was = card.querySelector('[data-od-bundle-was]');
        if (was) { was.innerHTML = p.was > p.now ? formatMoney(p.was) : ''; }
        var save = card.querySelector('[data-od-bundle-save]');
        if (save) {
          var savePct = p.was > p.now ? Math.round((p.was - p.now) * 100 / p.was) : 0;
          save.textContent = savePct > 0 ? (save.dataset.template || 'You save [percent]%').replace('[percent]', savePct).replace('[amount]', formatMoney(p.was - p.now).replace(/<[^>]+>/g, '')) : '';
        }
      });
      renderUnits(bundle, units);
      if (bundle && addonsBox && addonsBox.dataset.attach === 'true') bundle.appendChild(addonsBox);

      var qty = bundle ? Number(bundle.dataset.qty) : 1;
      var pct = bundle ? Number(bundle.dataset.pct) : 0;
      qtyInput.value = qty;
      var total = unitsBox(bundle) ? listPrices(units, pct) : tierPrices(variant, qty, pct);

      el.querySelectorAll('[data-od-price-now]').forEach(function (n) { n.innerHTML = formatMoney(variant.price); });
      el.querySelectorAll('[data-od-price-was]').forEach(function (n) {
        var show = variant.compare_at_price && variant.compare_at_price > variant.price;
        n.innerHTML = show ? formatMoney(variant.compare_at_price) : '';
      });

      if (button) {
        button.disabled = !variant.available;
        var label = button.querySelector('.od-btn__label');
        label.textContent = variant.available ? button.dataset.label : button.dataset.soldOut;
      }
      var stock = el.querySelector('[data-od-stock]');
      if (stock) {
        var limit = Number(stock.dataset.threshold) || 0;
        var left = variant.inventory;
        var showStock = typeof left === 'number' && left > 0 && left <= limit;
        stock.classList.toggle('od-hidden', !showStock);
        if (showStock) {
          stock.querySelector('[data-od-stock-text]').textContent = (stock.dataset.template || '').replace('[count]', left);
          stock.querySelector('[data-od-stock-bar]').style.width = Math.max(6, Math.round(left * 100 / limit)) + '%';
        }
      }

      if (sticky) {
        sticky.querySelector('[data-od-sticky-price]').innerHTML =
          formatMoney(total.now) + (total.was > total.now ? '<s>' + formatMoney(total.was) + '</s>' : '');
        var sb = sticky.querySelector('[data-od-sticky-atc]');
        sb.disabled = !variant.available;
      }
    }

    function onOptionChange() {
      var chosen = [];
      el.querySelectorAll('[data-od-option]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        chosen.push(c ? c.value : null);
        var lbl = fs.querySelector('[data-od-option-label]');
        if (lbl && c) lbl.textContent = c.value;
      });
      var match = data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      })[0];
      if (!match) return;
      applyVariant(match);
    }

    function applyVariant(match) {
      idInput.value = match.id;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
      if (match.featured_media_id) {
        var slide = el.querySelector('[data-media-id="' + match.featured_media_id + '"]');
        if (slide) slide.parentNode.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      render();
    }

    function submit(trigger) {
      var variant = currentVariant();
      if (!variant.available) return;
      if (errorBox) errorBox.classList.add('od-hidden');
      var items = [];
      var bundle = selectedBundle();
      if (unitsBox(bundle)) {
        var counts = {}, order = [];
        unitList(bundle).forEach(function (v) { if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); } counts[v.id]++; });
        order.forEach(function (id) { items.push({ id: id, quantity: counts[id], properties: { _funnel: data.handle } }); });
      } else {
        items.push({ id: variant.id, quantity: Number(qtyInput.value) || 1, properties: { _funnel: data.handle } });
      }
      el.querySelectorAll('[data-od-addon-input]:checked').forEach(function (input) {
        items.push({ id: Number(input.value), quantity: 1, properties: { _funnel: data.handle, _addon: 'true' } });
      });
      [button, trigger].forEach(function (b) { if (b) b.classList.add('is-loading'); });
      Drawer.add(items)
        .catch(function (err) {
          if (errorBox) { errorBox.textContent = err.message; errorBox.classList.remove('od-hidden'); errorBox.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        })
        .then(function () { [button, trigger].forEach(function (b) { if (b) b.classList.remove('is-loading'); }); });
    }

    el.addEventListener('change', function (e) {
      if (e.target.matches('[data-od-unit]')) {
        var idx = Number(e.target.getAttribute('data-od-unit'));
        var picked = variantById(Number(e.target.value));
        if (!picked) return;
        unitMemory[idx] = picked.id;
        if (idx === 0) {
          var fieldsets = el.querySelectorAll('[data-od-option]');
          if (fieldsets.length) {
            picked.options.forEach(function (val, oi) {
              var fs = fieldsets[oi];
              if (!fs) return;
              fs.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === val; });
            });
            onOptionChange();
          } else {
            applyVariant(picked);
          }
        } else {
          if (picked.featured_media_id) {
            var sl = el.querySelector('[data-media-id="' + picked.featured_media_id + '"]');
            if (sl) sl.parentNode.scrollTo({ left: sl.offsetLeft, behavior: 'smooth' });
          }
          render();
        }
        return;
      }
      if (e.target.closest('[data-od-option]')) onOptionChange();
      else if (e.target.closest('[data-od-bundle]')) render();
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(button); });

    if (sticky) {
      var stickyBtn = sticky.querySelector('[data-od-sticky-atc]');
      stickyBtn.addEventListener('click', function () { submit(stickyBtn); });
      if ('IntersectionObserver' in window && button) {
        var seen = false;
        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          if (entry.isIntersecting) seen = true;
          var show = !entry.isIntersecting && (seen || entry.boundingClientRect.top < 0);
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          document.body.classList.toggle('od-has-sticky', show);
        }).observe(button);
      }
    }
    render();
  }

  /* ---------- sliders (gallery, quotes) ---------- */
  function initSlider(el) {
    var track = el.querySelector('[data-od-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(el.querySelectorAll('[data-od-goto]'));
    var counter = el.querySelector('[data-od-current]');
    var active = 0;
    function setActive(i) {
      active = i;
      dots.forEach(function (d) { var on = Number(d.dataset.odGoto) === i; d.classList.toggle('is-active', on); if (on && d.scrollIntoView && d.classList.contains('od-gallery__thumb')) { d.parentNode.scrollTo({ left: d.offsetLeft - d.parentNode.clientWidth / 2 + d.clientWidth / 2, behavior: 'smooth' }); } });
      if (counter) counter.textContent = i + 1;
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var target = slides[Number(d.dataset.odGoto)];
        if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / (slides[0].offsetWidth + (parseFloat(getComputedStyle(track).columnGap) || 0)));
        if (i !== active && slides[i]) setActive(i);
      });
    }, { passive: true });
    var auto = Number(el.dataset.autoplay || 0);
    if (auto && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var timer = setInterval(function () {
        var next = (active + 1) % slides.length;
        track.scrollTo({ left: slides[next].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }, auto * 1000);
      ['touchstart', 'pointerdown', 'focusin'].forEach(function (evt) { el.addEventListener(evt, function () { clearInterval(timer); }, { once: true, passive: true }); });
    }
    setActive(0);
  }

  /* ---------- countdown to a real deadline ---------- */
  function initCountdown(el) {
    var end = Date.parse(el.dataset.odCountdown);
    if (isNaN(end)) { el.remove(); return; }
    var cells = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { el.remove(); clearInterval(timer); return; }
      cells.d.textContent = pad(Math.floor(left / 86400));
      cells.h.textContent = pad(Math.floor((left % 86400) / 3600));
      cells.m.textContent = pad(Math.floor((left % 3600) / 60));
      cells.s.textContent = pad(left % 60);
      el.classList.remove('od-hidden');
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- delivery timeline ---------- */
  function initTimeline(el) {
    var locale = document.documentElement.lang || 'en';
    function addBusinessDays(from, days) {
      var d = new Date(from);
      while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
      return d;
    }
    function fmt(d) { return d.toLocaleDateString(locale, { month: 'short', day: 'numeric' }); }
    function range(a, b) { return a.getTime() === b.getTime() ? fmt(a) : fmt(a) + ' – ' + fmt(b); }
    var now = new Date();
    var n = function (k) { return parseInt(el.dataset[k], 10) || 0; };
    var readyA = addBusinessDays(now, n('readyMin')), readyB = addBusinessDays(now, n('readyMax'));
    var delA = addBusinessDays(now, n('deliverMin')), delB = addBusinessDays(now, n('deliverMax'));
    var set = function (sel, text) { var node = el.querySelector(sel); if (node) node.textContent = text; };
    set('[data-od-date="ordered"]', fmt(now));
    set('[data-od-date="ready"]', range(readyA, readyB));
    set('[data-od-date="delivered"]', range(delA, delB));
  }

  /* ---------- lazy video: play only while visible ---------- */
  function initLazyVideos() {
    var videos = document.querySelectorAll('video[data-od-lazy]');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (!v.dataset.loaded) {
            v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
            v.load(); v.dataset.loaded = '1';
          }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.pause(); }
      });
    }, { threshold: 0.5 });
    videos.forEach(function (v) { io.observe(v); });
  }

  /* ---------- boot ---------- */
  function boot() {
    Drawer.init();
    document.querySelectorAll('[data-od-product]').forEach(initProduct);
    document.querySelectorAll('[data-od-slider]').forEach(initSlider);
    document.querySelectorAll('[data-od-countdown]').forEach(initCountdown);
    document.querySelectorAll('[data-od-timeline]').forEach(initTimeline);
    initLazyVideos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-od-product]').forEach(initProduct);
    e.target.querySelectorAll('[data-od-slider]').forEach(initSlider);
    e.target.querySelectorAll('[data-od-countdown]').forEach(initCountdown);
    e.target.querySelectorAll('[data-od-timeline]').forEach(initTimeline);
    initLazyVideos();
  });

  window.odCart = Drawer;
})();
